{
  "common": {
    "save": "Save",
    "cancel": "Cancel",
    "delete": "Delete",
    "edit": "Edit",
    "create": "Create",
    "loading": "Loading...",
    "saving": "Saving...",
    "search": "Search",
    "confirm": "Confirm"
  },
  "sidebar": {
    "dashboard": "Dashboard",
    "users": "Users",
    "brands": "Stores",
    "categories": "Categories",
    "institutions": "Causes",
    "transactions": "Transactions",
    "donations": "Donations",
    "coupons": "Coupons",
    "sync": "Sync",
    "integrations": "Integrations",
    "blog": "Blog",
    "marketing": "Marketing",
    "international": "International",
    "localization": "Localization"
  },
  "toasts": {
    "saved": "Changes saved successfully.",
    "error": "Something went wrong. Please try again."
  },
  "localization": {
    "title": "Localization",
    "description": "Set the public site language and your dashboard language.",
    "publicSiteLanguage": "Public site language (global)",
    "publicSiteLanguageHelp": "Shown to visitors. Affects the entire public site.",
    "dashboardLanguage": "My dashboard language",
    "dashboardLanguageHelp": "Only for your account. Doesn't affect the public site or other admins.",
    "savePublic": "Save public language",
    "saveDashboard": "Save my language",
    "publicSaved": "Public language updated.",
    "dashboardSaved": "Your dashboard language was updated."
  }
}